import { InfoCircle } from '@sainsburys-tech/icons'
import React from 'react'

import Banner from './Banner'

interface IInfoBannerProps {
  message: string
}

const InfoBanner = ({ message }: IInfoBannerProps) => (
  <Banner
    data-testid='info-banner'
    message={message}
    icon={<InfoCircle />}
    className='c-common-banner--info'
  />
)

export default InfoBanner
